export const configType = {
  FREE_TRIAL_DAYS: "FREE_TRIAL_DAYS"
};